import { useEffect, useState } from 'react';
import Button from '@mui/material/Button';
import CssBaseline from '@mui/material/CssBaseline';
import TextField from '@mui/material/TextField';
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useNavigate, useParams } from 'react-router-dom';
import { AUTHENTICATION, GLOBAL_CONSTANTS, PASDWORDREGEX, ROUTES, TOASTER_CONFIGS } from '../../constants';
import { nullUndefinedEmptyCheck } from '../../utils/helper';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import { useResetPasswordMutation } from '../../service/apiSlices/authService';
import { toast } from 'react-toastify';
import { Avatar } from '@mui/material';
import Logo from "../../assets/logo.svg";
import LeftSidContainer from '../login/leftSidePart';

function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            {'Copyright © '}
            <Link color="inherit" href="/">
                {GLOBAL_CONSTANTS.MAINTITLE}
            </Link>{' '}
            {new Date().getFullYear()}
            {'.'}
        </Typography>
    );
}

// TODO remove, this demo shouldn't need to reset the theme.
const defaultTheme = createTheme();

export default function ResetPassword() {
    const navigate = useNavigate();
    const { id }: any = useParams();
    const [uid, setUid] = useState("");
    const [token, setToken] = useState("");
    const [Visibility, setVisibility] = useState('password')
    const [VisibilityConfirm, setVisibilityConfirm] = useState('password')
    const [loginInfo, setLoginInfo] = useState({
        password: '',
        confirm_password: '',
    });
    const [error, setError] = useState<any>({
        password: '',
        confirm_password: '',
    })
    const [errorMsg, setErrorMsg] = useState({
        password: '',
        confirm_password: '',
    })
    useEffect(() => {
        let paramData = id?.split("-**-") ?? [];
        setUid(paramData[0]);
        setToken(paramData[1]);
    }, [id]);

    //handle input changes 
    const kychandleChange = (name: any, value: any) => {
        setLoginInfo({ ...loginInfo, [name]: value });

        // Validate the fields as the user types
        if (name === 'password' || name === 'confirm_password') {
            validatePasswords(name, value);
        }
    };

    const validatePasswords = (name: any, value: any) => {
        let passwordError = '';
        let confirmPasswordError = '';
        if (name === 'password') {
            if (value.length < 8) {
                passwordError = AUTHENTICATION.FIELDS_ERROR_MESSAGES.PASSWORD_REQUIRED;
            } else if (!PASDWORDREGEX.test(value)) {
                passwordError = 'Password must contain at least one capital letter and one special character';
            }
        }

        if (name === 'confirm_password' && value !== loginInfo.password) {
            confirmPasswordError = AUTHENTICATION.FIELDS_ERROR_MESSAGES.PASSWORD_MISMATCH;
        }

        setErrorMsg({
            ...errorMsg,
            password: passwordError,
            confirm_password: confirmPasswordError,
        });

        setError({
            ...error,
            password: !!passwordError,
            confirm_password: !!confirmPasswordError,
        });
    };

    const [ResetPasswordApiCall] = useResetPasswordMutation();

    const handleSubmit = (event: any) => {
        event.preventDefault();

        if (loginInfo.password.length < 8) {
            setErrorMsg({ ...errorMsg, password: AUTHENTICATION.FIELDS_ERROR_MESSAGES.PASSWORD_REQUIRED });
            setError({ ...error, password: true });
            return;
        }

        if (loginInfo.password !== loginInfo.confirm_password) {
            setErrorMsg({ ...errorMsg, confirm_password: AUTHENTICATION.FIELDS_ERROR_MESSAGES.PASSWORD_MISMATCH });
            setError({ ...error, confirm_password: true });
            return;
        }

        if (!error.password && !error.confirm_password && nullUndefinedEmptyCheck(loginInfo.password)
            && nullUndefinedEmptyCheck(loginInfo.confirm_password)) {

            var payload = {
                password: loginInfo.password,
                confirm_password: loginInfo.confirm_password,
                uid: uid,
                token: token
            }

            ResetPasswordApiCall(payload)
                .unwrap()
                .then((response) => {
                    // console.log('response', response)
                    toast.success(response?.message, TOASTER_CONFIGS);
                    navigate(ROUTES.LOGIN);
                })
                .catch((error) => {
                    toast.error(error?.data?.message, TOASTER_CONFIGS);
                })
        }
    };

    return (
        <ThemeProvider theme={defaultTheme}>
            <Grid container style={{ height: '100vh' }}>
                {/* Left side with background image */}
                <LeftSidContainer />

                {/* Right side with login form */}
                <Grid item xs={12} md={6} sx={{
                    display: 'flex',
                    alignItems: 'center',
                }}>
                    <Container component="main" maxWidth="xs">
                        <CssBaseline />
                        <Box
                            sx={{
                                marginTop: 8,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                            }}
                        >
                            <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                                <img src={Logo} width={50} height={50} alt='logo' />
                            </Avatar>
                            <Typography component="h1" variant="h5">
                                Reset Your Password?
                            </Typography>
                            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>

                                <TextField
                                    name='password'
                                    onChange={(e) => kychandleChange(e.target.name, e.target.value)}
                                    onBlur={(e) => kychandleChange(e.target.name, e.target.value)}
                                    onFocus={(e) => kychandleChange(e.target.name, e.target.value)}
                                    label='password'
                                    variant='outlined'
                                    helperText={errorMsg.password}
                                    value={loginInfo.password}
                                    error={error?.password}
                                    margin="normal"
                                    type={Visibility}
                                    fullWidth
                                    inputProps={{ inputmode: 'password' }}
                                    InputProps={Visibility === 'password' ? {
                                        endAdornment: <span style={{ zIndex: 1000, cursor: 'pointer' }} onClick={() => setVisibility('text')}><VisibilityOffOutlinedIcon /></span>
                                    } : {
                                        endAdornment: <span style={{ zIndex: 1000, cursor: 'pointer' }} onClick={() => setVisibility('password')}><VisibilityOutlinedIcon /></span>
                                    }}
                                />
                                <TextField
                                    name='confirm_password'
                                    onChange={(e) => kychandleChange(e.target.name, e.target.value)}
                                    onBlur={(e) => kychandleChange(e.target.name, e.target.value)}
                                    onFocus={(e) => kychandleChange(e.target.name, e.target.value)}
                                    label='confirm_password'
                                    variant='outlined'
                                    helperText={errorMsg.confirm_password}
                                    value={loginInfo.confirm_password}
                                    error={error?.confirm_password}
                                    margin="normal"
                                    type={VisibilityConfirm}
                                    fullWidth
                                    inputProps={{ inputmode: 'password' }}
                                    InputProps={VisibilityConfirm === 'password' ? {
                                        endAdornment: <span style={{ zIndex: 1000, cursor: 'pointer' }} onClick={() => setVisibilityConfirm('text')}><VisibilityOffOutlinedIcon /></span>
                                    } : {
                                        endAdornment: <span style={{ zIndex: 1000, cursor: 'pointer' }} onClick={() => setVisibilityConfirm('password')}><VisibilityOutlinedIcon /></span>
                                    }}
                                />

                                <Button
                                    type="submit"
                                    fullWidth
                                    variant="contained"
                                    sx={{ mt: 3, mb: 2, background: `${GLOBAL_CONSTANTS.COLOR_CODE.GRADIENT}` }}
                                >
                                    Submit
                                </Button>
                                <Grid container>
                                    <Grid item xs>
                                        <Link href={ROUTES.LOGIN} variant="body2">
                                            Back to login?
                                        </Link>
                                    </Grid>
                                </Grid>
                            </Box>
                        </Box>
                        {/* <Copyright sx={{ mt: 8, mb: 4 }} /> */}
                    </Container>
                </Grid>
            </Grid>
        </ThemeProvider>
    );
}